import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import classNames from 'classnames';
import propTypes from 'prop-types';
import {
    CardFooter,
} from 'reactstrap';
import { TextRupiah } from '../Text';
export default class SneakerHeader extends Component{
    renderLatestPrice(){
        if(this.props.latestPrice===null)
            return(
                <div className={classNames('sneaker-price', { 'd-none': !this.props.outOfStockLabel })}>
                    <p className="text-danger text-center text-bold" style={{margin:0}}>Out of Stock</p>
                </div>
            )
        return(
          <div className="sneaker-price" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <TextRupiah value={this.props.latestPrice.asking_price} prefix="RP " className="price-tag" />
              {/* <span className="price-label" style={{ fontSize: 7 }}>Harga Dimulai dari</span> */}
          </div>
        );
    }
    render(){
        return(
            <CardFooter className="wrapper-footer" style={{ background: 'transparent', border: 'none' }}>
                {this.renderLatestPrice()}
            </CardFooter>
        )
    }
}

SneakerHeader.propTypes = {
    outOfStockLabel:propTypes.bool,
    latestPrice:propTypes.object,
}
SneakerHeader.defaultProps={
    outOfStockLabel: true,
    latestPrice: null,
}